export default __webpack_public_path__ + "static/media/mt_portfolio-06.303b2007.png";